import { connect } from 'react-redux';
import { branch, compose, renderComponent, withProps } from 'recompose';

import requestsStatuses from 'modules/common/constants/requestsStatuses';
import { scrollRestored, appointmentSizeUpdated } from 'modules/queues/Schedule/actions/appointmentsScroll';
import { fetchMoreAppointments } from 'modules/queues/Schedule/actions/fetchAppointments';
import { canFetchMoreAppointments, scrollToIndex } from 'modules/queues/Schedule/selectors/appointments';
import {
  AppointmentsList,
  AppointmentsSidebarFetchErrorPlaceholder,
  AppointmentsFetchPendingPlaceholder,
  AppointmentCustomTemplateEmptyPlaceholder,
  AppointmentsNoResultsPlaceholder,
} from 'modules/queues/common/components';
import { hasFiltersEnabled } from 'modules/queues/Schedule/selectors/appointmentsFilters';

import { AppointmentCard } from '../';

const mapStateToProps = (state) => ({
  status: state.queues.schedule.appointments.status,
  appointmentsById: state.queues.schedule.appointments.byId,
  scrollToIndex: scrollToIndex(state),
  shouldUpdateListCache: state.queues.schedule.appointmentsScroll.shouldUpdateListCache,
  canFetchMoreAppointments: canFetchMoreAppointments(state),
  hasFiltersEnabled: hasFiltersEnabled(state),
});


const mapDispatchToProps = {
  scrollRestored,
  appointmentSizeUpdated,
  fetchMoreAppointments,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(() => ({
    AppointmentCard,
  })),

  branch(
    ({ status }) => status === requestsStatuses.failure,
    renderComponent(AppointmentsSidebarFetchErrorPlaceholder),
  ),
  branch(
    ({ status }) => status === requestsStatuses.pending,
    renderComponent(AppointmentsFetchPendingPlaceholder),
  ),
  branch(
    ({ appointmentsById, hasFiltersEnabled }) => appointmentsById.length === 0 && hasFiltersEnabled,
    renderComponent(AppointmentsNoResultsPlaceholder),
  ),
  branch(
    ({ appointmentsById }) => appointmentsById.length === 0,
    renderComponent(AppointmentCustomTemplateEmptyPlaceholder),
  ),
)(AppointmentsList);
